import LoadingSplash from "@atoms/atom-components/src/components/LoadingSplash";

export function ProjectSplashScreen() {
  return <LoadingSplash appName="Emerge" />;
}
